import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { salesOrderService } from '../api/services/salesOrderService';
import { CreateSalesOrderDTO } from '@shared/types/Order';
import toast from 'react-hot-toast';

export function useSalesOrder(orderId: number) {
  return useQuery({
    queryKey: ['salesOrder', orderId],
    queryFn: () => salesOrderService.getSalesOrderById(orderId),
    enabled: !!orderId,
  });
}

export function useCreateSalesOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateSalesOrderDTO) => salesOrderService.createSalesOrder(data),
    onSuccess: () => {
      toast.success('Sales order created successfully');
      queryClient.invalidateQueries({ queryKey: ['salesOrders'] });
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to create sales order');
    },
  });
}
